import { IAuthState } from "constants/interfaces/auth.interface";
import {
  IAuthAction,
} from "constants/interfaces/store.interface";
import { AUTH_TYPES } from "store/actions/types";

const authReducer = (
  state: IAuthState = {
    isLoggedIn: false,
    user: null,
    uuid: null,
    token: null,
  },
  action: IAuthAction
) => {
  switch (action.type) {
    case AUTH_TYPES.GENERATE_TOKEN:
      return {
        ...state,
        uuid: action.payload.uuid,
      };
    case AUTH_TYPES.LOG_IN:
      return {
        ...state,
        user: action.payload.user,
        isLoggedIn: action.payload.isLoggedIn,
        token: action.payload.token,
      };
    case AUTH_TYPES.LOG_OUT:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        uuid: null,
        token: null,
      };
    default:
      return state;
  }
};

export default authReducer;
